import { getUserAttribute } from "../user";
import { UserAttributes } from "../../constants";

export function userHasRole(
  role: string | string[]
): boolean | Record<string, boolean> {
  const rolePermission = getUserAttribute<string[]>(UserAttributes.Role, []);

  if (typeof role === "string") {
    return rolePermission.includes(role);
  }

  return role.reduce(
    (acc, role) => ({ ...acc, [role]: rolePermission.includes(role) }),
    {}
  );
}
